import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HrService } from '../../../services/human-resources/hr.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPenToSquare, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-department-management',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, FontAwesomeModule],
  templateUrl: './department-management.component.html',
  styleUrls: ['./department-management.component.scss']
})
export class DepartmentManagementComponent implements OnInit {
  // Icon definitions
  editIcon = faPenToSquare;
  deleteIcon = faTrash;
  addIcon = faPlus;

  departments: any[] = [];
  showDepartmentModal = false;
  departmentForm: FormGroup;
  editingDepartment: any = null;

  constructor(
    private hrService: HrService,
    private fb: FormBuilder
  ) {
    this.departmentForm = this.fb.group({
      name: ['', Validators.required],
      status: [1]
    });
  }

  ngOnInit(): void {
    this.loadDepartments();
  }

  loadDepartments(): void {
    this.hrService.getDepartments().subscribe({
      next: (departments) => {
        console.log('[Department Management] Departments:', departments);
        this.departments = departments.map((department: any) => department?.dataValues ?? department);
      },
      error: (error) => {
        console.error('Error loading departments:', error);
      }
    });
  }

  openAddDepartmentModal(): void {
    this.editingDepartment = null;
    this.departmentForm.reset();
    this.showDepartmentModal = true;
  }

  editDepartment(department: any): void {
    this.editingDepartment = department;
    this.departmentForm.patchValue({
      name: department.name,
      status: department.status
    });
    this.showDepartmentModal = true;
  }

  toggleStatus(department: any): void {
    const newStatus = department.status === 1 ? 0 : 1;
    this.hrService.updateDepartment(department.id, { ...department, status: newStatus }).subscribe({
      next: () => {
        this.loadDepartments();
      },
      error: (error) => {
        console.error('Error toggling department status:', error);
      }
    });
  }

  saveDepartment(): void {
    if (this.departmentForm.invalid) {
      return;
    }

    const departmentData = this.departmentForm.value;

    if (this.editingDepartment) {
      this.hrService.updateDepartment(this.editingDepartment.id, departmentData).subscribe({
        next: () => {
          this.loadDepartments();
          this.closeDepartmentModal();
        },
        error: (error) => {
          console.error('Error updating department:', error);
        }
      });
    } else {
      this.hrService.createDepartment(departmentData).subscribe({
        next: () => {
          this.loadDepartments();
          this.closeDepartmentModal();
        },
        error: (error) => {
          console.error('Error creating department:', error);
        }
      });
    }
  }

  closeDepartmentModal(): void {
    this.showDepartmentModal = false;
    this.departmentForm.reset();
    this.editingDepartment = null;
  }
} 